import { render, staticRenderFns } from "./UpdateConsultReason.vue?vue&type=template&id=59cb34e4"
import script from "./UpdateConsultReason.vue?vue&type=script&lang=js"
export * from "./UpdateConsultReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports